import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('path', { id: 'Artboard-32' }),
  React.createElement('path', { d: 'M27.44 14.88l-3.36-3.36-.92.92 2.91 2.91H13.32v1.3h12.75l-2.91 2.92.92.92 3.36-3.37a1.58 1.58 0 0 0 0-2.24z' }),
  React.createElement('path', { d: 'M16.37 27a11 11 0 1 1 7.3-19.14l.87-1a12.28 12.28 0 1 0 0 18.28l-.87-1a10.92 10.92 0 0 1-7.3 2.86z' })
));